import {clearStorage, getAuthToken, getSessionToken, getUid, showErrorToast} from "../helpers";
import {parseBotResponse} from "./utils";

let sessionId; // token per gestione interna di typebot, restituito da startchat
let chatId; // creato lato client per gestione reset del contesto del bot
let retryContinueChatCounter = 0;
//gestione new chat
let hasDraftChat = true;
let isReviewExposed = false; // true se nella risposta attuale c'è possibilità di review

export function getSessionId() {
  return sessionId;
}
export function setSessionId(value) {
  /*
  * può accettare null
  * */
  sessionId = value;
}

export function getChatId() {
  if (!chatId) chatId = generateChatId();
  return chatId
}

export function setChatId(value) {
  chatId = value
}

export function resetChatId() {
  chatId = null;
}

export function generateChatId() {
  return Date.now();
}

export function getHasDraftChat() {
  return hasDraftChat;
}

export function setHasDraftChat(value) {
  hasDraftChat = value;
}

export function getIsReviewExposed() {
  return isReviewExposed;
}

export function setIsReviewExposed(value) {
  isReviewExposed = value;
}

export function resetSessionState(options = {isDraft: true}) {
  // rimuove flag per indicare che è esposto blocco recensione
  setIsReviewExposed(false);

  // resetta id della chat
  resetChatId()

  // resetta sessionId di typebot
  setSessionId(null)

  // resetta flag per nuova conversazione
  setHasDraftChat(options?.isDraft)
}

export async function sendQuestion(message = '') {
  /*
  * faccio continueChat se:
  * - ho già sessionId restituito da typebot tramite startChat
  * - IsReviewExposed è FALSE, perché nel caso in cui viene esposto il blocco review, per inviare punteggio devo
  *   fare continueChat, per inviare il messaggio successivo devo fare invece startChat
  * */
  if (sessionId && !getIsReviewExposed()) {
    return await continueChat(message);
  } else {
    setIsReviewExposed(false)
    return await startChat(message);
  }
}

export async function startChat(message) {
  if (!message) throw new Error('Inviare un messaggio valido');

  const body = {
    uid: getUid(),
    text: message,
    chatId: getChatId()
  }
  const url = `${window.location.origin}/api/v1/chatbot/startchat`;
  const settings = await buildTypebotApiSettings(url, body);

  try {
    const response = await jQuery.ajax(settings)
    if (response?.sessionId) {
      sessionId = response.sessionId;
    }
    // se bot non risponde con campo input non è ancora pronto per ricevere domanda
    if (typebotResponseContainsInput(response)) {
      return continueChat(message);
    }

    // dopo aver risposto ad una domanda, fa continue finché bot non risponde con campo input
    await continueChatUntilInput();


    return parseBotResponse(response);
  } catch (err) {
    if (sessionId) sessionId = null;
    clearStorage();
    throw new Error(err);
  }
}

export async function continueChat(message) {
  if (!message) throw new Error('Inviare un messaggio valido');
  if (!sessionId) return await startChat(message);

  const body = {
    uid: getUid(),
    text: message,
    sessionId,
    chatId: getChatId()
  }
  const url = `${window.location.origin}/api/v1/chatbot/continuechat`;
  const settings = await buildTypebotApiSettings(url, body);

  try {
    const response = await jQuery.ajax(settings)
    const parsedResponse = parseBotResponse(response);

    if (parsedResponse.collect_feedback) {
      // se arriva collect_feedback a true la prossima continue manda opzioni per il blocco rating, quindi deve saltare
      await jQuery.ajax(settings);
    }

    // dopo aver risposto ad una domanda, fa continue finché bot non risponde con campo input
    await continueChatUntilInput();
    return parsedResponse
  } catch (err) {
    sessionId = null;
    clearStorage();
    console.log(err)
    if (err && err.status && err.status === 404) {
      // return await startChat(message);
      return;
    }
    throw new Error(err)
  }
}

export async function buildTypebotApiSettings(url, body) {
  const token = await getAuthToken();
  const sessionToken = await getSessionToken();

  return {
    "url": url,
    "method": "POST",
    "timeout": 0,
    "headers": {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + token,
      "X-CSRF-Token": sessionToken
    },
    "data": JSON.stringify(body),
  };
}

// dopo aver ricevuto rissposta dal bot, serve fare continue finché nel payload non trova un campo input. A quel punto può ricevere una nuova domanda
export async function continueChatUntilInput() {
  if (!sessionId) return;

  const body = {
    uid: getUid(),
    text: 'next',
    sessionId,
    chatId: getChatId()
  }
  const url = `${window.location.origin}/api/v1/chatbot/continuechat`;
  const settings = await buildTypebotApiSettings(url, body);

  try {
    if (retryContinueChatCounter >= 10) throw new Error();
    const response = await jQuery.ajax(settings)
    retryContinueChatCounter++
    if (typebotResponseContainsInput(response)) return
    return await continueChatUntilInput();
  } catch (err) {
    sessionId = null;
    clearStorage();
  } finally {
    retryContinueChatCounter = 0;
  }
}

function typebotResponseContainsInput(response) {
  return response.input && typeof response.input === 'object' && Object.keys(response.input).length > 0;
}


export async function deleteMrBrainChatById(chatId) {
  try {
    const token = await getAuthToken();
    const sessionToken = await getSessionToken();
    const uid = getUid();

    const url = `${window.location.origin}/api/v1/chatbot/user/${uid}/chat/${chatId}`;

    const settings = {
      url: url,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token,
        "X-CSRF-Token": sessionToken
      }
    };

    return await jQuery.ajax(settings);
  } catch (err) {
    console.error('Errore deleteMrBrainChatById:', err.status, err.responseText);
    throw err;
  }
}


export async function getHistoryChatList() {
  try {
    const token = await getAuthToken();
    const sessionToken = await getSessionToken();
    const uid = getUid();

    if (!uid) {
      console.error("UID non trovato");
      return [];
    }

    const url = `${window.location.origin}/api/v1/chatbot/user-chat/${uid}`;

    const settings = {
      url: url,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token,
        "X-CSRF-Token": sessionToken
      }
    };

    const response = await jQuery.ajax(settings);

    // Ritorna la lista o un array vuoto se la risposta è nulla
    return response.chats || [];

  } catch (error) {
    console.error('Errore getHistoryChatList:', error.status, error.statusText, error.responseText);
    showErrorToast("Errore durante il caricamento della chat");
    return [];
  }
}

export async function getChatDetail(chatId, params) {
  try {

    const token = await getAuthToken();
    const CSRFToken = await getSessionToken();
    const uid = getUid();

    let page = "1"
    if (params && params["page"]) page = params["page"]
    let limit = "50"
    if (params && params["limit"]) limit = params["limit"]

    const url = `${window.location.origin}/api/v1/chatbot/user/${uid}/chat/${chatId}?page=${page}&limit=${limit}`;

    const settings = {
      "url": url,
      "method": 'GET',
      "headers": {
        "Content-Type": "application/json",
        "X-CSRF-Token": CSRFToken,
        "Authorization": "Bearer " + token
      }
    };
    const response = await jQuery.ajax(settings);
    return response;

  } catch (error) {
    console.error('Errore getChatDetail:', error.status, error.responseText);
    showErrorToast("Errore durante il caricamento della chat");
    return null;
  }
}
